import React from "react"

const Loader = ({absolute, fixed, absoluteFlex}) => {
    return(
<div style={fixed ? {left: 0, top: 0} : {}} className={absolute === true ? 'loader-ireview-absolute' : absoluteFlex === true ? 'loader-review-absolute-flex' : 'loader-ireview'}><img src={"/admin-images/loading_ireview.gif"} alt="loader" /></div>    )
}
export default Loader